import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-city-terminal expense" }
const _hoisted_2 = { class: "wrap-content" }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Pengeluaran", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 sm:grid-cols-3 gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 label-text" }, /*#__PURE__*/_toDisplayString('Jenis Pengeluaran')),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, /*#__PURE__*/_toDisplayString('Nominal'))
], -1)
const _hoisted_8 = { class: "sm:col-span-2" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "p-inputgroup flex-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_12 = { class: "flex grouping-button gap-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Form = _resolveComponent("Form", true)!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow card" }, {
      title: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.isEdit ? 'Edit' : 'Tambah') + " Pengeluaran", 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Form, {
                  onSubmit: _ctx.onSubmit,
                  "validation-schema": _ctx.schema,
                  "initial-values": _ctx.initialValues,
                  class: "form-container",
                  id: "fixed-expense-form"
                }, {
                  default: _withCtx(({ errors, setFieldValue, values }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_Field, { name: "name" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            class: `input-primary ${errors.name ? 'input-invalid' : ''}`,
                            placeholder: "Tulis Nama pengeluaran"
                          }), null, 16, ["onChange", "onBlur", "class"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(errors.name), 1)
                    ]),
                    _hoisted_7,
                    _createVNode(_component_FieldArray, { name: "expenseDetail" }, {
                      default: _withCtx(({ fields, push, remove }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "grid grid-cols-2 sm:grid-cols-3 gap-4",
                            key: field.key
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_Field, {
                                name: `expenseDetail[${idx}].type`
                              }, {
                                default: _withCtx(({ field, handleChange, handleBlur }) => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_InputText, _mergeProps({
                                      onChange: handleChange,
                                      onBlur: handleBlur,
                                      class: `input-primary ${errors[`expenseDetail[${idx}].type`] ? 'input-invalid' : ''}`,
                                      placeholder: "xxxxxx"
                                    }, field, { readonly: "" }), null, 16, ["onChange", "onBlur", "class"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["name"])
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_Field, {
                                name: `expenseDetail[${idx}].nominal`,
                                class: _normalizeClass(`input-primary ${errors[`expenseDetail[${idx}].nominal`] ? 'input-invalid' : ''}`)
                              }, {
                                default: _withCtx(({ field, handleChange, handleBlur }) => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createVNode(_component_InputText, _mergeProps({
                                      type: "number",
                                      placeholder: "0",
                                      min: 0,
                                      max: 99999999.99,
                                      step: 0.25
                                    }, field, {
                                      modelValue: field.value,
                                      "onUpdate:modelValue": (val) => setFieldValue(`expenseDetail[${idx}].nominal`, val)
                                    }), null, 16, ["max", "step", "modelValue", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["name", "class"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema", "initial-values"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            class: "btn-back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBack()))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "submit",
            form: "fixed-expense-form",
            class: "btn-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}